module.exports = __webpack_public_path__ + "static/media/19a-04_Pintura-gris-2019-200x180cm-oleo-sobre-madera.7fa0f1e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/19a/19a-04_Pintura-gris-2019-200x180cm-oleo-sobre-madera.jpg
// module id = 239
// module chunks = 0